import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import NavigateSpan from '../Utils/NavigateSpan';
import { sessionUserLoggedIn, sessionUserID } from '../Core/LoginManager'

const UserProfileDropdownPopup = ( props ) =>
{
  const [ showToast, setShowToast ] = useState( false );

  const handleCopyId = ( e ) =>
  {
    e.stopPropagation();
    navigator.clipboard.writeText( sessionUserID );
    setShowToast( true );
    setTimeout( () => setShowToast( false ), 2000 );
  };

  return (

    <Modal
      show={ true }
      onHide={ () => { } }
      backdrop="static"
      className="top-bar-profile-dropdown-modal" >
      <Modal.Body>
        <div className="component-dropdown-panel">



          {/* NOTE: Commented this PROFILE buttont out for now. Will re-enable when the styling for the PRofile page is finished. */ }
          <NavigateSpan href={ "/profile/" + props.username } newTab={ true } >
            View Profile
          </NavigateSpan>





          <span onClick={ () => { props.onEditUsernameRequested(); } } >
            Edit Username
          </span>






          <>
            { !sessionUserLoggedIn && (

              <span onClick={ props.onLoginRequested }>
                Login
              </span>

            ) }

            { sessionUserLoggedIn && (

              <span onClick={ props.onLogout }>
                Logout
              </span>

            ) }
          </>

          { sessionUserID && (
            <div style={ { position: 'relative' } }>
              <div
                onClick={ handleCopyId }
                style={ {
                  fontSize: '10px',
                  color: '#999',
                  cursor: 'pointer',
                  marginTop: '10px',
                  padding: '0px 4px',
                  borderRadius: '2px',
                  userSelect: 'none',
                  textAlign: 'right'
                } }
                title="Click to copy User ID to clipboard"
              >
                ID: { sessionUserID } 📋
              </div>

              { showToast && (
                <div
                  style={ {
                    position: 'absolute',
                    top: '-30px',
                    right: '0px',
                    backgroundColor: '#333',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '10px',
                    whiteSpace: 'nowrap',
                    opacity: showToast ? 1 : 0,
                    transition: 'opacity 0.3s ease-in-out',
                    zIndex: 1000,
                    pointerEvents: 'none'
                  } }
                >
                  ID Copied to Clipboard
                </div>
              ) }
            </div>
          ) }

        </div>
      </Modal.Body>

    </Modal>
  );
}

export default UserProfileDropdownPopup;
